import React, { useEffect, useState } from 'react'
import { Box } from 'rebass/styled-components'
import { getFluidImageObject } from 'gatsby-transformer-cloudinary/api'
import { useInView } from 'react-intersection-observer'
import ImageLoader from '../loaders/ImageLoader'
import Image from 'gatsby-image';
import BackgroundImage from 'gatsby-background-image'
import { getGatsbyStaticImageObj } from '../../helpers/Functions'
// import { isSet } from 'util/types'
// import { typeOf } from 'react-is'

const ImageRender = ({ file, alt, options, orientation }) => {
    const [fluid, setFluid] = useState(false)
    const [ref, inView] = useInView()

    useEffect(() => {
        if (!file.type || file.type !== 'static') {
            const isTeamMedia = (file.filepath !== 'website/team/') ? false : true
            const mediaWidth = ( isTeamMedia ) ? 768 :1920
            const mediaHeight = ( isTeamMedia ) ? 1024 : 1080
            const imageOrientation = orientation || 'center'
            const image = `${options.overlay ? 'l_website:qEA1R9yFlvNTDU]qF7k': ''}/${file.filepath}${file.filename.replace(/[(]/g, '_').replace(/[)]/g, '')}`
            async function getData() {
                setFluid(false)
                getFluidImageObject({
                    public_id: image,
                    cloudName: 'kidston',
                    originalHeight: mediaHeight,
                    originalWidth: mediaWidth,
                    breakpoints: [200, 400, 600, 800, 1920],
                    transformations: ['c_fill'],
                    maxWidth: 1920,
                }).then((result) => {
                    if (options && options.backgroundImage) {
                        setFluid(<BackgroundImage fluid={result} alt={alt} style={{ width: '100%', height: '100%', backgroundPosition: imageOrientation }} />)
                    } else {
                        setFluid(<Image fluid={result} alt={alt} />)
                    }
                })
            }
            if (inView) {
                getData()
            }
        } else {
            const imgObj = getGatsbyStaticImageObj(file.filepath)
            if (options && options.backgroundImage) {
                setFluid(<BackgroundImage fluid={imgObj} alt={alt} style={{ width: '100%', height: '100%' }} />)
            } else {
                setFluid(<Image fluid={imgObj} alt={alt} />)
            }
        }
    }, [file, inView, options])

    return <Box ref={ref} height='100%' width='100%'> {fluid ? fluid : <ImageLoader />}</Box>
}

export default ImageRender
